module.exports = __webpack_public_path__ + "images/thumbs-down93cd18bb2fe23c0ab61339b7352a1b11.svg";